
// ─── Route map ────────────────────────────────────────────────────────────────
import AuthorizationReleaseOfInformation   from "./Form01_AuthorizationReleaseOfInformation";
import AuthorizationForm                   from "./Form02_AuthorizationForm";
import ChronicCareManagement               from "./Form03_ChronicCareManagement";
import VestibularFunctionConsent           from "./Form04_VestibularFunctionConsent";
import ElectronicCommunicationsDisclosure  from "./Form05_ElectronicCommunicationsDisclosure";
import FallAssessmentSurvey                from "./Form06_FallAssessmentSurvey";
import PatientCareAuthorization            from "./Form07_PatientCareAuthorization";
import PatientHealthHistoryQuestionnaire   from "./Form08_PatientHealthHistoryQuestionnaire";
import PatientHistoryForm                  from "./Form09_PatientHistoryForm";
import PatientRegistrationForm             from "./Form10_PatientRegistrationForm";
import PatientResponsibilityForFeesV1      from "./Form11_PatientResponsibilityForFeesV1";
import PolicyPatientResponsibilityForFees  from "./Form12_PolicyPatientResponsibilityForFees";
import RemoteMonitoring                    from "./Form13_RemoteMonitoring";
import ReviewOfSystems                     from "./Form14_ReviewOfSystems";
import TelemedicineConsent                 from "./Form15_TelemedicineConsent";
import WellnessPreventiveAssessment        from "./Form16_WellnessPreventiveAssessment";

/**
 * index.js  —  Gazelle EHX Clinical Forms
 * Origo Health · All 16 patient intake forms
 *
 * Usage in your React Router setup:
 *   import { FORM_ROUTES } from './forms';
 *   FORM_ROUTES.forEach(({ path, component: C }) =>
 *     <Route path={path} element={<C patientName={...} practiceName={...} />} />
 *   );
 *
 * npm install react-signature-canvas jspdf html2canvas react-router-dom
 */

export { default as AuthorizationReleaseOfInformation }   from "./Form01_AuthorizationReleaseOfInformation";
export { default as AuthorizationForm }                    from "./Form02_AuthorizationForm";
export { default as ChronicCareManagement }                from "./Form03_ChronicCareManagement";
export { default as VestibularFunctionConsent }            from "./Form04_VestibularFunctionConsent";
export { default as ElectronicCommunicationsDisclosure }   from "./Form05_ElectronicCommunicationsDisclosure";
export { default as FallAssessmentSurvey }                 from "./Form06_FallAssessmentSurvey";
export { default as PatientCareAuthorization }             from "./Form07_PatientCareAuthorization";
export { default as PatientHealthHistoryQuestionnaire }    from "./Form08_PatientHealthHistoryQuestionnaire";
export { default as PatientHistoryForm }                   from "./Form09_PatientHistoryForm";
export { default as PatientRegistrationForm }              from "./Form10_PatientRegistrationForm";
export { default as PatientResponsibilityForFeesV1 }       from "./Form11_PatientResponsibilityForFeesV1";
export { default as PolicyPatientResponsibilityForFees }   from "./Form12_PolicyPatientResponsibilityForFees";
export { default as RemoteMonitoring }                     from "./Form13_RemoteMonitoring";
export { default as ReviewOfSystems }                      from "./Form14_ReviewOfSystems";
export { default as TelemedicineConsent }                  from "./Form15_TelemedicineConsent";
export { default as WellnessPreventiveAssessment }         from "./Form16_WellnessPreventiveAssessment";


/** Matches `id` in `PdfFormFiller` FORM_LIST (`/public/forms/…`) for view-only PDF routes */
export const FORM_ROUTES = [
  {
    seq:        1,
    path:       "/forms/01-authorization-release-of-information",
    component:  AuthorizationReleaseOfInformation,
    title:      "Authorization for Release of Information",
    pdfFormId:  "Authorization for Release of Information",
    collection: "authorization_release_of_information",
    apiRoute:   "/api/forms/authorization-release-of-information",
    next:       "/forms/02-authorization-form",
  },
  {
    seq:        2,
    path:       "/forms/02-authorization-form",
    component:  AuthorizationForm,
    title:      "Authorization Form",
    pdfFormId:  "Authorization Form",
    collection: "authorization_forms",
    apiRoute:   "/api/forms/authorization-form",
    next:       "/forms/03-chronic-care-management",
  },
  {
    seq:        3,
    path:       "/forms/03-chronic-care-management",
    component:  ChronicCareManagement,
    title:      "Chronic Care Management Program",
    pdfFormId:  "Chronic Care Management Program",
    collection: "chronic_care_management",
    apiRoute:   "/api/forms/chronic-care-management",
    next:       "/forms/04-vestibular-consent",
  },
  {
    seq:        4,
    path:       "/forms/04-vestibular-consent",
    component:  VestibularFunctionConsent,
    title:      "Consent for In-Office Vestibular Function Procedures",
    pdfFormId:  "Consent for In Office Vestibular Function Procedures",
    collection: "vestibular_consent",
    apiRoute:   "/api/forms/vestibular-consent",
    next:       "/forms/05-electronic-communications",
  },
  {
    seq:        5,
    path:       "/forms/05-electronic-communications",
    component:  ElectronicCommunicationsDisclosure,
    title:      "Electronic Communications Disclosure",
    pdfFormId:  "Electronic Communications Disclosure",
    collection: "electronic_communications_disclosure",
    apiRoute:   "/api/forms/electronic-communications-disclosure",
    next:       "/forms/06-fall-assessment",
  },
  {
    seq:        6,
    path:       "/forms/06-fall-assessment",
    component:  FallAssessmentSurvey,
    title:      "Fall Assessment Survey",
    pdfFormId:  "Fall Assessment Survey",
    collection: "fall_assessment_surveys",
    apiRoute:   "/api/forms/fall-assessment",
    next:       "/forms/07-patient-care-authorization",
  },
  {
    seq:        7,
    path:       "/forms/07-patient-care-authorization",
    component:  PatientCareAuthorization,
    title:      "Patient Care Authorization",
    pdfFormId:  "Patient Care Authorization",
    collection: "patient_care_authorizations",
    apiRoute:   "/api/forms/patient-care-authorization",
    next:       "/forms/08-health-history-questionnaire",
  },
  {
    seq:        8,
    path:       "/forms/08-health-history-questionnaire",
    component:  PatientHealthHistoryQuestionnaire,
    title:      "Patient Health History Questionnaire",
    pdfFormId:  "Patient Health History Questionnaire",
    collection: "patient_health_history",
    apiRoute:   "/api/forms/patient-health-history",
    next:       "/forms/09-patient-history-form",
  },
  {
    seq:        9,
    path:       "/forms/09-patient-history-form",
    component:  PatientHistoryForm,
    title:      "Patient History Form",
    pdfFormId:  "Patient History Form",
    collection: "patient_history_forms",
    apiRoute:   "/api/forms/patient-history",
    next:       "/forms/10-patient-registration",
  },
  {
    seq:        10,
    path:       "/forms/10-patient-registration",
    component:  PatientRegistrationForm,
    title:      "Patient Registration Form",
    pdfFormId:  "Patient Registration Form",
    collection: "patient_registrations",
    apiRoute:   "/api/forms/patient-registration",
    next:       "/forms/11-patient-responsibility-fees-v1",
  },
  {
    seq:        11,
    path:       "/forms/11-patient-responsibility-fees-v1",
    component:  PatientResponsibilityForFeesV1,
    title:      "Policy on Patient Responsibility for Fees (V1)",
    pdfFormId:  "Patient Responsibility for Fees - Policy",
    collection: "patient_responsibility_fees_v1",
    apiRoute:   "/api/forms/patient-responsibility-fees-v1",
    next:       "/forms/12-policy-patient-responsibility-fees",
  },
  {
    seq:        12,
    path:       "/forms/12-policy-patient-responsibility-fees",
    component:  PolicyPatientResponsibilityForFees,
    title:      "Policy on Patient Responsibility for Fees (V2)",
    pdfFormId:  "Policy on Patient Responsibility for Fees",
    collection: "patient_responsibility_fees_v2",
    apiRoute:   "/api/forms/patient-responsibility-fees-v2",
    next:       "/forms/13-remote-monitoring",
  },
  {
    seq:        13,
    path:       "/forms/13-remote-monitoring",
    component:  RemoteMonitoring,
    title:      "Remote Monitoring Consent",
    pdfFormId:  "Remote Monitoring",
    collection: "remote_monitoring_consents",
    apiRoute:   "/api/forms/remote-monitoring",
    next:       "/forms/14-review-of-systems",
  },
  {
    seq:        14,
    path:       "/forms/14-review-of-systems",
    component:  ReviewOfSystems,
    title:      "Review of Systems (ROS)",
    pdfFormId:  "Review of Systems Form",
    collection: "review_of_systems",
    apiRoute:   "/api/forms/review-of-systems",
    next:       "/forms/15-telemedicine-consent",
  },
  {
    seq:        15,
    path:       "/forms/15-telemedicine-consent",
    component:  TelemedicineConsent,
    title:      "Telemedicine Consent",
    pdfFormId:  "Telemedicine Consent",
    collection: "telemedicine_consents",
    apiRoute:   "/api/forms/telemedicine-consent",
    next:       "/forms/16-wellness-preventive-assessment",
  },
  {
    seq:        16,
    path:       "/forms/16-wellness-preventive-assessment",
    component:  WellnessPreventiveAssessment,
    title:      "Annual Wellness / Preventive Assessment",
    pdfFormId:  "Wellness Preventive Assesssment",
    collection: "wellness_assessments",
    apiRoute:   "/api/forms/wellness-assessment",
    next:       "/dashboard",
  },
];

/**
 * ─── MongoDB collections (16 total) ──────────────────────────────────────────
 *
 *  authorization_release_of_information
 *  authorization_forms
 *  chronic_care_management
 *  vestibular_consent
 *  electronic_communications_disclosure
 *  fall_assessment_surveys
 *  patient_care_authorizations
 *  patient_health_history
 *  patient_history_forms
 *  patient_registrations
 *  patient_responsibility_fees_v1
 *  patient_responsibility_fees_v2
 *  remote_monitoring_consents
 *  review_of_systems
 *  telemedicine_consents
 *  wellness_assessments
 *
 * ─── Express router wiring example ───────────────────────────────────────────
 *
 *  import { FORM_ROUTES } from './forms';
 *  FORM_ROUTES.forEach(({ apiRoute }) => {
 *    app.use(apiRoute, require(`./routes${apiRoute}`));
 *  });
 *
 * ─── React Router wiring example ─────────────────────────────────────────────
 *
 *  import { FORM_ROUTES } from './forms';
 *  <Routes>
 *    {FORM_ROUTES.map(({ path, component: Comp }) => (
 *      <Route key={path} path={path}
 *        element={<Comp patientName={ctx.patientName} practiceName={ctx.practiceName} />} />
 *    ))}
 *  </Routes>
 */
